import React from 'react';
import PropTypes from 'prop-types';

const ArrowIcon = ({ style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" style={style}>
    <path d="M.47,8.91,7.06,2.66a1.66,1.66,0,0,1,1.57-.42A1.57,1.57,0,0,1,9.79,3.33a1.5,1.5,0,0,1-.45,1.49L5.44,8.51h13a1.53,1.53,0,1,1,0,3.06H5.48l3.86,3.66a1.48,1.48,0,0,1,0,2.14,1.68,1.68,0,0,1-2.25,0L.47,11.15A1.51,1.51,0,0,1,0,10.06V10A1.48,1.48,0,0,1,.47,8.91Z" />
  </svg>
);

ArrowIcon.propTypes = {
  style: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.objectOf(PropTypes.string),
  ]),
};

ArrowIcon.defaultProps = {
  style: null,
};

export default ArrowIcon;
